import { ApolloClient, InMemoryCache } from "@apollo/client";
import { CREATE_QUEUE_RECORD_MUTATION } from "../mutations/createQueueRecordMutation";
import { UPDATE_QUEUE_RECORD_MUTATION } from "../mutations/updateQueueRecordMutation";
import { DELETE_QUEUE_RECORD_MUTATION } from "../mutations/deleteQueueRecordMutation";
import { GET_QUEUE_RECORD_QUERY } from "../queries/getQueueRecordQuery";
import { LIST_QUEUE_RECORDS_QUERY } from "../queries/listQueueRecordsQuery";

const GRAPHQL_ENDPOINT =
  "https://cniiawccbfcc5jpaiqsgx7npfi.appsync-api.us-east-1.amazonaws.com/graphql";

// const GRAPHQL_ENDPOINT =
//   "https://gomiocbjmvdilowjdnezqh5jzq.appsync-api.us-east-1.amazonaws.com/graphql";

// Initialize Apollo Client for queue services
const queueClient = new ApolloClient({
  uri: GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
  headers: {
    "x-api-key": "da2-3l4nsfogmrbb7g2brojjwmdlue",
    // Alternative header format if needed
    // "Authorization": "Bearer da2-na5luul3pfdqbfoqwymkmkfmvq",
  },
});

/**
 * Test function to debug API connection issues
 * Call this to verify the API configuration
 */
export const testApiConnection = async () => {
  console.group("🧪 Testing API Connection");

  console.log("📋 Configuration:");
  console.log(`  Endpoint: ${GRAPHQL_ENDPOINT}`);
  console.log(`  API Key: da2-na5luul3pfdqbfoqwymkmkfmvq`);

  try {
    // Test with a simple query to check connectivity
    const testInput = {
      name: "Test Queue Record",
      status: "pending",
      data: '{"test": "data"}',
    };

    console.log("🔄 Testing API call...");
    const result = await createQueueRecordApi(testInput);

    console.log("✅ API call successful:", result);
    return { success: true, result };
  } catch (error) {
    console.error("❌ API call failed:", error);
    console.error("🔍 Error details:");
    console.error("  Message:", error.message);
    console.error("  GraphQL Errors:", error.graphQLErrors);
    console.error("  Network Error:", error.networkError);

    return { success: false, error };
  } finally {
    console.groupEnd();
  }
};

// API call to create a new queue record
export const createQueueRecordApi = async (input) => {
  console.log(
    `PMM - SF - queueServicesApi.js - createQueueRecordApi - input is: ${JSON.stringify(
      input
    )}`
  );

  console.log(
    `PMM - SF - queueServicesApi.js - Using endpoint: ${GRAPHQL_ENDPOINT}`
  );
  console.log(
    `PMM - SF - queueServicesApi.js - Using API key: da2-na5luul3pfdqbfoqwymkmkfmvq`
  );

  const apiPayload = {
    mutation: CREATE_QUEUE_RECORD_MUTATION,
    variables: { input },
  };

  console.log(
    `PMM - SF - queueServicesApi.js - createQueueRecordApi - apiPayload is: ${JSON.stringify(
      apiPayload
    )}`
  );

  try {
    const response = await queueClient.mutate(apiPayload);

    return response.data.createQueueRecord;
  } catch (error) {
    console.error(`Error creating queue record: ${error.message}`);
    console.error(`Full error details:`, error);
    console.error(`GraphQL errors:`, error.graphQLErrors);
    console.error(`Network error:`, error.networkError);
    throw error;
  }
};

// API call to update an existing queue record
export const updateQueueRecordApi = async (queueRecordInput) => {
  console.log(
    `Queue Services API - updateQueueRecordApi - queueRecordInput: ${JSON.stringify(
      queueRecordInput
    )}`
  );

  try {
    const response = await queueClient.mutate({
      mutation: UPDATE_QUEUE_RECORD_MUTATION,
      variables: { input: queueRecordInput },
    });

    return response.data.updateQueueRecord;
  } catch (error) {
    console.error(`Error updating queue record: ${error.message}`);
    throw error;
  }
};

// API call to delete a queue record
export const deleteQueueRecordApi = async (id) => {
  console.log(`Queue Services API - deleteQueueRecordApi - id: ${id}`);

  try {
    const response = await queueClient.mutate({
      mutation: DELETE_QUEUE_RECORD_MUTATION,
      variables: { id },
    });

    return response.data.deleteQueueRecord;
  } catch (error) {
    console.error(`Error deleting queue record: ${error.message}`);
    throw error;
  }
};

// API call to retrieve a single queue record
export const getQueueRecordApi = async (id) => {
  console.log(`Queue Services API - getQueueRecordApi - id: ${id}`);

  try {
    const response = await queueClient.query({
      query: GET_QUEUE_RECORD_QUERY,
      variables: { id },
      fetchPolicy: "network-only", // Ensures fresh data on each query
    });

    return response.data.getQueueRecord;
  } catch (error) {
    console.error(`Error fetching queue record: ${error.message}`);
    throw error;
  }
};

// API call to list queue records
export const listQueueRecordsApi = async (limit, nextToken) => {
  console.log(
    `Queue Services API - listQueueRecordsApi - limit: ${limit}, nextToken: ${nextToken}`
  );

  try {
    const response = await queueClient.query({
      query: LIST_QUEUE_RECORDS_QUERY,
      variables: { limit, nextToken },
      fetchPolicy: "network-only", // Ensures fresh data on each query
    });

    return response.data.listQueueRecords;
  } catch (error) {
    console.error(`Error fetching queue records: ${error.message}`);
    throw error;
  }
};
